export enum EServerType {
  VLLM = "vLLM",
  TGI = "TGI",
}

export interface IServerType {
  type: EServerType;
  image: string;
}
